import { connect } from 'react-redux'

import UserCongratulationsPopup from './UserCongratulationsPopup'
import {
  endSurveyLink,
  isPostSurveyLink,
  getIdentityName,
  activeProTrackLevel,
  isPostTrackSurveyEnabled,
} from 'store/entities/identity/selectors'
import { requestSurvey, markEndSurveyRequested, updateOnboardingChecklist } from 'store/entities/identity/actions'
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { modal } from 'store/entities/modal/actions'
import { IS_QUIZ_COMPLETED } from 'app/constants/onBoarding'

const mapStateToProps = state => ({
  postSurveyLink: endSurveyLink(state),
  isPostSurveyLink: isPostSurveyLink(state),
  userName: getIdentityName(state),
  activeProTrackLevel: activeProTrackLevel(state),
  isPostTrackSurveyEnabled: isPostTrackSurveyEnabled(state),
})

const mapDispatchToProps = {
  requestSurvey: sendEmail => requestSurvey({ surveyType: 'end', sendEmail }),
  showTypeFormPopup,
  hideModal: modal.hide,
  markEndSurveyRequested,
  updateOnboardingChecklist,
}

const mergeProps = (
  { postSurveyLink, ...restState },
  { showTypeFormPopup, requestSurvey, hideModal, markEndSurveyRequested, updateOnboardingChecklist },
  own
) => ({
  ...restState,
  ...own,
  requestSurvey: sendEmail => {
    requestSurvey(sendEmail)
    hideModal()
  },
  handleCloseModal: () => {
    markEndSurveyRequested(true)
    hideModal()
  },
  showTypeFormPopup: () =>
    showTypeFormPopup({
      typeFormLink: postSurveyLink,
      onSubmit: () => {
        requestSurvey(false)
        updateOnboardingChecklist({ propertyName: IS_QUIZ_COMPLETED, propertyValue: true })
        hideModal()
      },
    }),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UserCongratulationsPopup)
